import { Cartesian3 } from "../geometry/geometry.cartesian";
export class DemInfos {
    static GetVector(z, i, stride) {
        const y = Math.floor(i / stride);
        const x = i - y * stride;
        return new Cartesian3(x, y, z);
    }
    constructor(elevations, normals = null, stride, pos, size) {
        this._max = Cartesian3.Zero();
        this._min = Cartesian3.Zero();
        this._delta = 0;
        this._mean = 0;
        this._elevations = null;
        this._normals = null;
        this._stride = 0;
        this._elevations = elevations;
        this._normals = normals;
        if (this._elevations) {
            const length = this._elevations?.length;
            this._stride = stride || Math.sqrt(length);
            let min = Number.MAX_SAFE_INTEGER;
            let max = Number.MIN_SAFE_INTEGER;
            let mean = -this._elevations[0] / length;
            let mini = 0;
            let maxi = 0;
            const x0 = pos?.x || 0;
            const x1 = x0 + (size?.width || this._stride);
            const y0 = pos?.y || 0;
            const y1 = y0 + (size?.height || this._stride);
            for (let y = y0; y < y1; y++) {
                const j = y * this._stride;
                for (let x = x0; x < x1; x++) {
                    const i = j + x;
                    const z = this._elevations[i];
                    if (z < min) {
                        min = z;
                        mini = i;
                    }
                    else if (z > max) {
                        max = z;
                        maxi = i;
                    }
                    mean += z / length;
                }
            }
            this._max = DemInfos.GetVector(max, maxi, this._stride);
            this._min = DemInfos.GetVector(min, mini, this._stride);
            this._delta = this._max.z - this._min.z;
            this._mean = mean;
        }
    }
    get max() {
        return this._max;
    }
    get min() {
        return this._min;
    }
    get delta() {
        return this._delta;
    }
    get mean() {
        return this._mean;
    }
    get elevations() {
        return this._elevations;
    }
    get normals() {
        return this._normals;
    }
    toString() {
        return `elevations count:${this._elevations?.length || 0}, min:{${this._min.toString()}}, max:{${this._max.toString()}}, delta:${this._delta}, mean:${this._mean}}`;
    }
    getDemInfoView(pos, size) {
        return new DemInfos(this._elevations, this._normals, this._stride, pos, size);
    }
}
//# sourceMappingURL=dem.infos.js.map